export type CmsStatus = 'meets_standard' | 'conditional' | 'at_risk'

export function mapScoreToCmsStatus(score: number): CmsStatus {
  if (score >= 95) return 'meets_standard'
  if (score >= 85) return 'conditional'
  return 'at_risk'
}

export function cmsStatusLabel(status: CmsStatus): string {
  if (status === 'meets_standard') return 'Meets Standard'
  if (status === 'conditional') return 'Conditional'
  return 'At Risk'
}

export function cmsStatusTone(status: CmsStatus): { text: string; bg: string } {
  if (status === 'meets_standard') return { text: 'text-emerald-700', bg: 'bg-emerald-50' }
  if (status === 'conditional') return { text: 'text-amber-700', bg: 'bg-amber-50' }
  return { text: 'text-rose-700', bg: 'bg-rose-50' }
}
